import { routes } from "../../../router/routes";

export const NavItems = [
  {
    linkTo: routes.directionsPage,
    text: "Направления"
  },
  {
    linkTo: routes.tariffsPage,
    text: "Тарифы"
  },
  {
    linkTo: routes.marketPage,
    text: "Маркет"
  },
  {
    linkTo: routes.helpPage,
    text: "Поддержка 24/7"
  },
]